<template>
    <div class="bay-item">
        <bay-item-name
        :name_object="bay_item.name_object"
        :index="index"
        :editable = "editable"
        v-on="$listeners"
        ></bay-item-name>
        <div class='two-column'>
            <bay-l-item
                :item="bay_item.l_object"
                :event_info="event_info"
                :is_bi="is_bi"
                :name = "bay_item.name_object.value"
                :index="index"
                v-on="$listeners"
            ></bay-l-item >
            <bay-r-item
                :item="bay_item.r_object"
                :event_info="event_info"
                :is_bi="is_bi"
                :name = "bay_item.name_object.value"
                :index="index"
                v-on="$listeners"
            ></bay-r-item>
        </div>
 
    </div>
    
</template>

<script>
import BayLItem from './coms/BayLItem.vue';
import BayRItem from './coms/BayRItem.vue';
import BayItemName from './coms/BayItemName.vue';


export default {
    name:'BayItem',
    props:{
        bay_item:Object,
        event_info:Object,//事件定义
        is_bi:Boolean,//正反事件标志
        index:Number,
        editable:Boolean,
    },
    data(){
        return {
            

        }
    },
    components:{
        BayLItem,BayRItem,BayItemName,
    }
    
    
}
</script>

<style lang="stylus" scoped>
@import '~css/var.styl';
.bay-item
    width:$item_width;
    // height:$source_height + $flow_height - 50px;
    //border:1px solid #ffff;
    border-radius:5px;
    padding:5px 3px;
    margin:10px 10px;
    box-shadow:1px 1px 2px gray,2px 2px 6px gray,-2px -2px 3px white;
    display:flex;
    flex-direction :column;
    //background-color:$bay_item_color;
    
    

    & :hover
        box-shadow:1px 2px 4px darkgray;

.two-column
    display:flex;
    flex:1;
    flex-direction :row;
    justify-content :space-around;


</style>
